<template>
  <section :id="id" :class="{ shaded: shaded }">
    <div class="row team-bio">
      <div class="columns image">
        <slot name="memberImage"></slot>
      </div>
      <div class="columns details">
        <h2>{{ name }}</h2>
        <h3>{{ memberTitle }}</h3>
        <div class="show-for-medium-down">
          <button class="toggle-bio button-link" @click="toggleBioExpanded">
            {{ expandBioTitle }}
          </button>
          <div v-show="bioExpanded" class="bio-content">
            <slot name="summary"></slot>
            <slot name="quote"></slot>
          </div>
        </div>
        <div class="bio-content show-for-large-up">
          <slot name="summary"></slot>
          <slot name="quote"></slot>
        </div>
      </div>
    </div>
    <section class="recommendations">
      <ProductGridCarousel
        :carousel-id="id"
        :items="products"
        :title="carouselTitle"
        :extra-card-count="1"
      >
        <template v-if="extraCardUrl && extraCardText" #extraCards>
          <li>
            <nuxt-link :to="extraCardUrl" class="view-more">
              <img
                src="~/assets/images/wa-icon-crate-inverted.svg"
                role="image"
                alt="Wine Crate"
                data-not-lazy
              />
              <span class="name">{{ extraCardText }}</span>
              <span class="button">Shop now</span></nuxt-link
            >
          </li>
        </template>
      </ProductGridCarousel>
    </section>
  </section>
</template>

<script>
export default {
  name: 'TeamMemberBio',
  components: {
    ProductGridCarousel: defineAsyncComponent(
      () => import('@/components/Product/ProductGridCarousel'),
    ),
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    shaded: {
      type: Boolean,
      required: false,
      default: false,
    },
    memberTitle: {
      type: String,
      required: true,
    },
    expandBioTitle: {
      type: String,
      required: true,
    },
    carouselTitle: {
      type: String,
      required: true,
    },
    extraCardUrl: {
      type: String,
      required: false,
      default: '',
    },
    extraCardText: {
      type: String,
      required: false,
      default: '',
    },
    products: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      bioExpanded: false,
    }
  },
  methods: {
    toggleBioExpanded() {
      this.bioExpanded = !this.bioExpanded
    },
  },
}
</script>
